import { useState } from 'react';
import { PROJECT_NAME } from '@pulsewright/shared';
import { useProjectStore } from './store/project';
import { AudioTest } from './components/AudioTest';
import { TrackerView } from './components/TrackerView';

/**
 * Top-level shell. Phase 1 step 6: tracker view shows the demo song.
 * The AudioTest panel below remains as a quick channel-level playground.
 * The /style-preview route (per PROJECT_BRIEF.md Open Decisions) lands
 * before we finalize the look — for now this is the "Modern dark" style.
 */
export function App() {
  const project = useProjectStore((s) => s.project);
  const [showAudioTest, setShowAudioTest] = useState(false);

  return (
    <main className="flex h-full flex-col items-center gap-6 overflow-auto p-6">
      <header className="flex w-full max-w-4xl flex-col items-start gap-1">
        <h1 className="text-2xl font-bold text-nes-cyan">{PROJECT_NAME}</h1>
        <p className="text-xs text-nes-white/50">
          NES chiptune tracker · Phase 1 step 6 · project &ldquo;{project.metadata.title}&rdquo;
        </p>
      </header>

      <TrackerView />

      <div className="w-full max-w-4xl border-t border-nes-cyan/10 pt-4">
        <button
          onClick={() => setShowAudioTest((v) => !v)}
          className="text-xs uppercase tracking-wider text-nes-white/50 hover:text-nes-cyan"
        >
          {showAudioTest ? '▼' : '▶'} Audio test panel (per-channel playground)
        </button>
        {showAudioTest && (
          <div className="mt-3">
            <AudioTest />
          </div>
        )}
      </div>
    </main>
  );
}
